module.exports = __webpack_public_path__ + "img/Imagen 9.27dbed21.jpg";